import React, { useEffect } from "react";

import { Container, Col, Row, Card } from "react-bootstrap";

import aboutUsImg from "../../../image/aboutUs/about-title.png";
import { WhyAzeto } from "../../../utility/content/aboutPage/WhyAzeto";
import { graph } from "../../../utility/content/aboutPage/Graph";

import scrollToTop from "../../../libs/scrollToTop";

import {
  StyledSection,
  CardsWrapper,
  CircleIcon,
  CardBody,
  GraphWrapper,
  StyledRow,
} from "./styledAboutUspage";
import { StyledMark } from "../../../style/base/styledPublicPages";
import { StyledTitleH3 } from "../home/testimonial/styledTestimonial";

const AboutUsPageComponent = () => {
  useEffect(() => {
    document.title = "درباره ما";
    scrollToTop();
  }, []);

  return (
    <>
      <h1 className="text-center m-5 pt-5">
        <StyledMark>درباره ما </StyledMark>
      </h1>
      <StyledSection className="first-gray-background pt-4">
        <Container>
          <Row>
            <Col md={12} lg={6} className="order-2 order-lg-1">
              <h3 className="title mt-5 mb-5 text-center text-lg-end">آزتو چیست؟</h3>
              <p className="subtitle d-flex align-items-center">
                آزتو به عنوان یکی از محصولات موسسه آموزشی فرآموز هنداسه، مجموعه ای از
                آزمایشگاه‌های علمی و درسی مجازی تحت وب و آنلاین می‌باشد که منطبق با
                محتوای آموزشی مصوب وزارت آموزش و پرورش و وزارت علوم است. این
                آزمایشگاه‌ها به صورت کاملا تعاملی طراحی شده‌اند تا دانش‌آموز بتواند
                احساس حضور در یک آزمایشگاه واقعی مدرسه را تجربه نماید. در آزتو،
                دانش‌آموز پس از ورود به وبسایت، آزمایش مورد نظر را انتخاب ، ستاپ
                آزمایش را تهیه و پارامترهای ورودی را تعیین کرده و برنامه شبیه سازی را
                اجرا می‌نماید و سپس نتایج آزمایش را به صورت اعداد خروجی و یا
                نمودارهای گرافیكی مشاهده می‌نماید. نتایج را با توجه به دانش و استنباط
                خود تحلیل و دسته‌بندی نموده و گزارش آن را تهیه می کند.
              </p>
            </Col>
            <Col
              md={12}
              lg={6}
              className="d-flex justify-content-center align-items-center order-1 order-lg-2"
            >
              <img
                src={aboutUsImg}
                alt="آزتو چیست"
                className="mx-auto img-fluid mt-3"
              />
            </Col>
          </Row>
        </Container>
      </StyledSection>
      <StyledSection className="why-azeto">
        <Container>
          <StyledTitleH3 className="mx-auto text-white mt-4 mt-lg-0">
            چرا‌ آزتو
          </StyledTitleH3>
          <StyledRow className="mt-lg-5">
            {WhyAzeto.map((item) => (
              <Col xs={12} lg={4} className="pt-5" key={item.id}>
                <CardsWrapper className="mx-auto d-flex flex-column justify-content-end align-items-center">
                  <CircleIcon
                    className="rounded-circle d-flex flex-column justify-content-around align-items-center"
                    $backgroundColor={item.background}
                  >
                    <img
                      src={item.img}
                      alt={`آیکون ${item.heading}`}
                      style={{ width: "90px", height: "auto", objectFit: "cover" }}
                      className={item.id === 2 ? "hat-styles" : ""}
                    />
                  </CircleIcon>
                  <CardBody className="text-center h-50 p-4 d-flex flex-column justify-content-center align-items-center">
                    <Card.Title className="title w-100 mt-5 mb-3 pt-md-3">
                      {item.heading}
                    </Card.Title>
                    <Card.Subtitle className="subtitle h-50 pt-3">
                      {item.body}
                    </Card.Subtitle>
                  </CardBody>
                </CardsWrapper>
              </Col>
            ))}
          </StyledRow>
        </Container>
      </StyledSection>
      <StyledSection className="last-gray-background pt-4">
        <StyledTitleH3 className="mx-auto mt-5 text-white">
          ویژگی‌های آزتو
        </StyledTitleH3>
        <GraphWrapper className="container position-relative">
          {graph.map((item) =>
            item.id === 7 ? (
              <span className={`nodes-Graph node${item.id}`} key={item.id}>
                {item.text}
              </span>
            ) : (
              <span key={item.id}>
                <span className={`lines-graph line${item.id}`}></span>
                <span className={`nodes-Graph node${item.id}`}>{item.text}</span>
              </span>
            )
          )}
        </GraphWrapper>
      </StyledSection>
    </>
  );
};

export default AboutUsPageComponent;
